import React, { createContext, useContext, useMemo } from 'react';
import {
  DEFAULT_CURRENCY,
  resolveCurrency,
  viewerLocale,
  formatCurrency as formatCurrencyUtil,
  parseCurrencyInput as parseCurrencyInputUtil,
  centsToInputString as centsToInputStringUtil,
  amountInputMode,
  amountInputProps,
  currencySymbol,
} from './currency';

const CurrencyContext = createContext(null);

export function CurrencyProvider({ currency, locale, children }) {
  const value = useMemo(() => {
    const code = resolveCurrency(currency);
    const loc = locale || viewerLocale();
    return {
      currency: code,
      locale: loc,
      symbol: currencySymbol(code, loc),
      inputMode: amountInputMode(code),
      amountInputProps: amountInputProps(code),
      formatCurrency: (cents) => formatCurrencyUtil(cents, code, loc),
      parseCurrencyInput: (input) => parseCurrencyInputUtil(input, loc, code),
      centsToInputString: (cents) => centsToInputStringUtil(cents, code, loc),
    };
  }, [currency, locale]);

  return <CurrencyContext.Provider value={value}>{children}</CurrencyContext.Provider>;
}

export function useCurrency() {
  const ctx = useContext(CurrencyContext);
  if (ctx) return ctx;
  const code = DEFAULT_CURRENCY;
  const loc = viewerLocale();
  return {
    currency: code,
    locale: loc,
    symbol: currencySymbol(code, loc),
    inputMode: amountInputMode(code),
    amountInputProps: amountInputProps(code),
    formatCurrency: (cents) => formatCurrencyUtil(cents, code, loc),
    parseCurrencyInput: (input) => parseCurrencyInputUtil(input, loc, code),
    centsToInputString: (cents) => centsToInputStringUtil(cents, code, loc),
  };
}

export function useFormatCurrency() {
  return useCurrency().formatCurrency;
}
